module.exports = __webpack_public_path__ + "img/gastroenterology.14969e26.png";